export enum SubmitStatus {
  IDLE = 0,
  SUBMITTING,
  SUCCESS,
  ERROR,
}
